export enum ORDER_TEMPLATE_TYPE {
	JobDescription = 0,
}
